import * as style from './Container.css';

import { createUseRecipeHook, RecipeVariants } from '@/theme';

export const useContainerStyle = createUseRecipeHook(style.root);
export type ContainerStyleProps = RecipeVariants<typeof style.root>;
